import React, { Component } from 'react'

import { labelsSchool, labelsSchoolAddOn } from './data'

class List extends Component {
  constructor (props, context) {
    super(props, context)

    this.listFeedback = this.listFeedback.bind(this)
    this.getLowestPrice = this.getLowestPrice.bind(this)
  }

  componentDidUpdate () {
    this.listFeedback()
  }

  /**
   * Animate some visual feedback when the list is updating.
   *
   * @var   list  The visible course list.
   */
  listFeedback () {
    var list = document.getElementById('kursfinder-list')
    list.classList.add('is--updating')
    setTimeout(function () {
      list.classList.remove('is--updating')
    }, 1000)
  }

  /**
   * Find the lowest price of all dates.
   *
   * @param   termine All termine from the course
   * @returns The lowest price
   */
  getLowestPrice (termine) {
    let prices = termine.map(termin => termin.price)
    prices = prices.filter(Boolean)
    prices = prices.map(function (x) { return parseInt(x, 10) })
    return Math.min(...prices)
  }

  getLowestFullPrice (termine) {
    let prices = termine.map(termin => termin.halfPrice)
    prices = prices.filter(Boolean)
    prices = prices.map(function (x) { return parseInt(x, 10) })
    return Math.min(...prices)
  }

  /**
   * Render the list of all (filtered) courses.
   *
   * @var   noResults Show some generic message if the filtered list has no courses. For improving: Make text editable in Backend.
   */
  render () {
    let noResults
    if (this.props.resultsCount === 0) {
      noResults = <div className='results-message'><strong>Leider konnten zu Ihren Suchkriterien keine Kurse/Angebote gefunden werden.</strong><br />Klicken Sie auf "Filter zurücksetzen" oder ändern Sie Ihre Filterauswahl, um nach passenden Angeboten zu suchen.<br />Alternativ sind wir gerne telefonisch unter 040/25 33 088-0 oder per E-Mail <a href='mailto:dhh@dhh.de'>dhh@dhh.de</a> für Sie erreichbar. Ihr DHH-Team</div>
    }
    return (
      <div id='kursfinder-list' className='filtered-list'>
        <ul>
          {this.props.filteredCourses.map(course =>
            <li className='course-item' key={course.category + course.name + course.school + course.agefrom + course.ageto + course.uid}>
              <div className='course-header'>
                <div className='course-header-img'>
                  {course.image_s ? (
                    <img src={course.image_s} alt='Kursbild' />
                  ) : (
                    <img src='/fileadmin/user_upload/Allgemeine_Bilder/Karte_klein.jpg' alt='Dummy' />
                  )}
                </div>
                <div className='course-header-info'>
                  <h3>{course.name}</h3>
                  <div className='location'>{labelsSchool[course.school]}

                    {course.category === '7' || course.category === '8' ? (
                      <span />
                    ) : (
                      <span><br />{labelsSchoolAddOn[course.school]}</span>
                    )}
                  </div>

                  <div>
                    {isFinite(this.getLowestPrice(course.termine)) ? (
                      <span>ab {this.getLowestPrice(course.termine).toLocaleString('de')},- &euro;</span>
                    ) : (
                      <span />
                    )}
                    {isFinite(this.getLowestFullPrice(course.termine)) ? (
                      <span> / ab {this.getLowestFullPrice(course.termine).toLocaleString('de')},- &euro; inkl. VP</span>
                    ) : (
                      <span />
                    )}
                  </div>
                  {course.detail ? (
                    <a className='btn btn-outline-primary' href={course.detail}>Details & Kurstermin{course.termine.length > 1 ? <span>e</span> : <span />} <i className='fa fa-angle-right' /></a>
                  ) : (
                    <span />
                  )}
                </div>
              </div>
              <ul className='dates'>
                {course.termine.map(termin =>
                  <li className='date-item' key={termin.cid}>
                    <div>
                      <span className='identifier'>Datum</span><br />
                      {termin.startDate !== '31.12.1969' && termin.endDate !== '31.12.1969' && termin.startDate !== '01.01.1970' && termin.endDate !== '01.01.1970' ? (
                        <span>{termin.startDate} - {termin.endDate}</span>
                      ) : (
                        <span>Offen</span>
                      )}
                      {termin.fullybooked === '1' ? (
                        <span className='fully-booked'>Kurs ausgebucht</span>
                      ) : (
                        <span />
                      )}
                    </div>
                    <div>
                      <span className='identifier'>Kursnummer</span><br />
                      {termin.cid}
                    </div>
                    {course.school >= 3 && termin.period ? (
                      <div>
                        <span className='identifier'>Zeitraum</span><br />
                        <span>{termin.period}</span>
                      </div>
                    ) : (
                      <span />
                    )}
                    {course.school < 3 ? (
                      <div>
                        <span className='identifier'>Preis Kurs</span><br />
                        {termin.price ? (
                          <span>{termin.price} &euro;</span>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    ) : (
                      <span />
                    )}
                    {course.school < 3 ? (
                      <div>
                        <span className='identifier'>Preis inkl. VP</span><br />
                        {termin.halfPrice ? (
                          <span>{termin.halfPrice} &euro;</span>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    ) : (
                      <span />
                    )}
                    <div>
                      <a className='btn btn-outline-primary' href={termin.forma}>Anfragen <i className='fa fa-angle-right' /></a>
                      <a className='btn btn-outline-primary' href={termin.form}>Buchen <i className='fa fa-angle-right' /></a>
                    </div>
                  </li>
                )}
              </ul>
            </li>
          )}
        </ul>
        {noResults}
      </div>
    )
  }
}

export default List
